import $ from 'jquery'
/*
 * PANEL SELECTOR JQuery
 */
const PANEL_SELECTOR = $('.reservation-panel')


export default class BoxReservationPanel {
  constructor () {
    // Attributes
    this.kind_val = undefined
    this.offer_val = undefined
    this.places_val = undefined
    this.products = undefined
    this.active_product = undefined

    // Init
    this.init()
    this.refreshActiveProduct()
    this.refreshPriceHeading()
    this.refreshPriceTable()
    this.refreshIncluded()
    this.initEventListener()
  }

  /*
   * Static Method
   * -------------------------------------------------------------------------------------------------------------------
   */

  static getClassName () { return 'ReservationPanel' }
  getClassName () { return ReservationPanel.getClassName() }

  /*
   * Init Methods
   * -------------------------------------------------------------------------------------------------------------------
   */
  init () {
    this.$selector = PANEL_SELECTOR
    this.$content = this.$selector.find('.reservation-panel-content')
    this.products = this.$selector.data('products')
    this.$price_heading = this.$selector.find('.price-heading')
    this.$close = this.$selector.find('.close')
    // Form
    this.$kind = this.$selector.find('input[name="kind"]')
    this.$offer = this.$selector.find('select[name="offer"]')
    this.$places = this.$selector.find('select[name="places"]')
    this.kind_val = this.$kind.filter(':checked').val()
    this.offer_val = this.$offer.val()
    this.places_val = this.$places.val()
    this.$form = this.$selector.find('form')
    // Price table
    this.$price_detail_table = this.$selector.find('.price-detail-table')
    // Included
    this.$included = this.$selector.find('#included')
    this.$not_included = this.$selector.find('#not-included')
    // Others
    this.$mobile_buttons = $('.mobile-buttons-container button')
    this.$authentication_modal = $('#authentication-modal')
    this.$selector[0]['manager'] = this
  }

  initEventListener () {
    this.$kind.on('change', () => {
      this.kind_val = this.$kind.filter(':checked').val()
      this.refreshActiveProduct()
      this.refreshPriceHeading()
      this.refreshPriceTable()
      this.refreshIncluded()
    })
    this.$offer.on('change', () => {
      this.offer_val = this.$offer.val()
      this.refreshActiveProduct()
      this.refreshPriceHeading()
      this.refreshPriceTable()
      this.refreshIncluded()
    })
    this.$places.on('change', () => {
      this.places_val = this.$places.val()
      this.refreshPriceTable()
    })
    this.$close.on('click', (e) => {
      // Hide panel
      this.$selector.attr( "style", "display: none !important;" )    
      // Show mobile buttons
      this.$mobile_buttons.attr( "style", "display: block !important;" )
    })
    this.$mobile_buttons.on('click', (e) => {
      // Hide mobile buttons
      this.$mobile_buttons.attr( "style", "display: none !important;" )
      // Resize and show panel
      //let h = $($(this.element).data('parent-width-ref')).width()
      let h = document.documentElement.clientHeight - $('.main-navbar').height();
      this.$content.addClass('mobile')
      this.$selector.attr( "style", "height:"+h+"px;display: block !important;" )
    })
    this.$form.on('submit', (e) => {
      if(!$('body').data('userloggedin')) {
        window.authenticationFormsLoader.load()
        return false;
      }
      return true;
    })
  }

  refreshActiveProduct(){
    let p
    if(this.kind_val == 1) {
      if(this.offer_val == 1) {
        p = this.products[3]
      } else {
        p = this.products[2]
      }
    } else {
      if(this.offer_val == 1) {
        p = this.products[1]
      } else {
        p = this.products[0]
      }
    }
    this.active_product = p
  }

  refreshPriceHeading() {
    this.$price_heading.find('.price').text(this.active_product.price_2pers / 2)
  }

  refreshPriceTable() {
    let unit_price
    if(this.places_val == 2) {
      unit_price = this.active_product.price_2pers / 2
    } else {
      unit_price = this.active_product.price_1pers
    }
    this.$price_detail_table.find('.unit_price').text(unit_price) 
    this.$price_detail_table.find('.travelers_nb').text(this.places_val)
    this.$price_detail_table.find('.total_price').text(unit_price * this.places_val)
    this.$price_detail_table.show()
  }

  refreshIncluded() {
    let ul

    ul = $('<ul></ul>').addClass('checklist-icon')
    for(var i = 0; i < this.active_product.included.length; i++ ){
      let li = $('<li></li>').text(this.active_product.included[i])
      li.prepend('<i class="fa fa-check"></i>')
      ul.append(li)
    }
    this.$included.html(ul)

    ul = $('<ul></ul>').addClass('checklist-icon')
    for(var i = 0; i < this.active_product.not_included.length; i++ ){
      let li = $('<li></li>').text(this.active_product.not_included[i])
      li.prepend('<i class="fa fa-ban"></i>')
      ul.append(li)
    }
    this.$not_included.html(ul)
  }

}



// WEBPACK FOOTER //
// ./box/static/box/js/components/box-reservation-panel.js